import { render } from "./RbDataTable.vue?vue&type=template&id=1b40eddb&scoped=true"
import script from "./RbDataTable.vue?vue&type=script&lang=js"
export * from "./RbDataTable.vue?vue&type=script&lang=js"

import "./RbDataTable.vue?vue&type=style&index=0&id=1b40eddb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b40eddb"]])

export default __exports__